import LocaleHost from '../../../../scripts/classes/LocaleHost';

/**
 * Form with Sidebar
 * @param  {[type]} options [description]
 * @return {[type]}         [description]
 */
var FormWithSidebar = function(options){

  this.options = {
    $el: false
  };

  $.extend(true, this.options, options);

  this.$form = this.options.$el.find("form");
  this.$submitButton = this.options.$el.find('form button[type="submit"]');

};

/**
 * Initing
 * @return {[type]} [description]
 */
FormWithSidebar.prototype.init = function(){

  var self = this;

  this.$form.on('onBeforeFormieSubmit', function(e) {

    let data = e.detail;

    if (typeof MsCrmMkt !== "undefined" && self.$form.attr('id') == 'formie-form-258562') {
      MsCrmMkt.MsCrmFormLoader.sendFormCaptureToCrm(e.currentTarget);
    }

    // set the language field that will be used for determining translations in email notifications
    var $formLanguageField = self.options.$el.find('[name="fields[formLanguage]"]');

    if ($formLanguageField.length) {
      var urlParams = new URLSearchParams(window.location.search);
      var formLanguageParam = urlParams.get('formLanguage');

      if (formLanguageParam) {
        $formLanguageField.val(formLanguageParam);
      } else {
        $formLanguageField.val(LocaleHost.getLocale(window.location.hostname) || 'en');
      }
    }

  });

};

export default  FormWithSidebar;
